import general from './general.json';
import exception from './exception.json';
import topLaunchScreen from './topLaunchScreen.json';
import topInputBirthday from './topInputBirthday.json';
import topTermsOfUse from './topTermsOfUse.json';
import topPersonalInformation from './topPersonalInformation.json';
import camera from './camera.json';
import cameraFaceCommonManualFront from './camera/face/common/manual/front.json';
import cameraFaceCommonManualAction from './camera/face/common/manual/action.json';
import cameraIdentityDocumentDriversLicenseManualFront from './camera/identity-document/drivers-license/manual/front.json';
import cameraIdentityDocumentDriversLicenseManualDiagonal from './camera/identity-document/drivers-license/manual/diagonal.json';
import cameraIdentityDocumentDriversLicenseManualBack from './camera/identity-document/drivers-license/manual/back.json';
import cameraIdentityDocumentDriversLicenseAutodetectFront from './camera/identity-document/drivers-license/autodetect/front.json';
import cameraIdentityDocumentDriversLicenseAutodetectDiagonal from './camera/identity-document/drivers-license/autodetect/diagonal.json';
import cameraIdentityDocumentDriversLicenseAutodetectBack from './camera/identity-document/drivers-license/autodetect/back.json';
import cameraIdentityDocumentMyNumberCardManualFront from './camera/identity-document/my-number-card/manual/front.json';
import cameraIdentityDocumentMyNumberCardManualDiagonal from './camera/identity-document/my-number-card/manual/diagonal.json';
import cameraIdentityDocumentMyNumberCardAutodetectFront from './camera/identity-document/my-number-card/autodetect/front.json';
import cameraIdentityDocumentMyNumberCardAutodetectDiagonal from './camera/identity-document/my-number-card/autodetect/diagonal.json';
import cameraIdentityDocumentResidenceCardManualFront from './camera/identity-document/residence-card/manual/front.json';
import cameraIdentityDocumentResidenceCardManualDiagonal from './camera/identity-document/residence-card/manual/diagonal.json';
import cameraIdentityDocumentResidenceCardManualBack from './camera/identity-document/residence-card/manual/back.json';
import cameraIdentityDocumentSpecialPermanentResidentCertificateManualFront from './camera/identity-document/special-permanent-resident-certificate/manual/front.json';
import cameraIdentityDocumentSpecialPermanentResidentCertificateManualDiagonal from './camera/identity-document/special-permanent-resident-certificate/manual/diagonal.json';
import cameraIdentityDocumentSpecialPermanentResidentCertificateManualBack from './camera/identity-document/special-permanent-resident-certificate/manual/back.json';
import cameraIdentityDocumentDrivingHistoryCertificateManualFront from './camera/identity-document/driving-history-certificate/manual/front.json';
import cameraIdentityDocumentDrivingHistoryCertificateManualDiagonal from './camera/identity-document/driving-history-certificate/manual/diagonal.json';
import cameraIdentityDocumentDrivingHistoryCertificateManualBack from './camera/identity-document/driving-history-certificate/manual/back.json';
import cameraIdentityDocumentDrivingHistoryCertificateAutodetectFront from './camera/identity-document/driving-history-certificate/autodetect/front.json';
import cameraIdentityDocumentDrivingHistoryCertificateAutodetectDiagonal from './camera/identity-document/driving-history-certificate/autodetect/diagonal.json';
import cameraIdentityDocumentDrivingHistoryCertificateAutodetectBack from './camera/identity-document/driving-history-certificate/autodetect/back.json';
import cameraIdentityDocumentPassportManualFront from './camera/identity-document/passport/manual/front.json';
import cameraIdentityDocumentPassportManualDiagonal from './camera/identity-document/passport/manual/diagonal.json';
import cameraIdentityDocumentPassportManualBack from './camera/identity-document/passport/manual/back.json';
import cameraIdentityDocumentHealthInsuranceCardManualFront from './camera/identity-document/health-insurance-card/manual/front.json';
import cameraIdentityDocumentHealthInsuranceCardManualDiagonal from './camera/identity-document/health-insurance-card/manual/diagonal.json';
import cameraIdentityDocumentHealthInsuranceCardManualBack from './camera/identity-document/health-insurance-card/manual/back.json';
import cameraIdentityDocumentStudentNotebook from './camera/identity-document/student-notebook';
import cameraIdentityDocumentPassportAnyIssuanceDate from './camera/identity-document/passport-any-issuance-date';
import cameraMynumberDocumentMyNumberCardManualBack from './camera/mynumber-document/my-number-card/manual/back.json';
import cameraMynumberDocumentMyNumberCardManualFront from './camera/mynumber-document/my-number-card/manual/front.json';
import cameraMynumberDocumentNotificationCardManualBack from './camera/mynumber-document/notification-card/manual/back.json';
import cameraMynumberDocumentNotificationCardManualFront from './camera/mynumber-document/notification-card/manual/front.json';
import cameraMynumberDocumentResidenceCertificateManualFront from './camera/mynumber-document/residence-certificate/manual/front.json';
import cameraIdentityDocumentGeneralBook from './camera/identity-document/general-book';
import cameraIdentityDocumentGeneralCard from './camera/identity-document/general-card';
import cameraGeneralPurposeDocumentCommonManualPage from './camera/general-purpose-document/common/manual/page.json';
import cameraOptionalDocumentCommonManualPage from './camera/optional-document/common/manual/page.json';
import cameraMode from './camera/camera-mode.json';
import Root from './Root.json';
import facetrackerFaceDirectionMessage from './facetrackerFaceDirectionMessage.json';
import facetrackerFaceDirection from './facetrackerFaceDirection.json';
import applicationCompletion from './applicationCompletion.json';
import cameraCameraChildError from './cameraCameraChildError.json';
import cameraCameraChildConfirmation from './cameraCameraChildConfirmation.json';
import cameraCameraChildIntroduction from './cameraCameraChildIntroduction.json';
import cameraCameraChildShooting from './cameraCameraChildShooting.json';
import componentsPageHeader from './componentsPageHeader.json';
import componentsMaintenanceView from './componentsMaintenanceView.json';
import componentsCameraPageShootCardAuto from './componentsCameraPageShootCardAuto.json';
import componentsCameraPageShootCheck from './componentsCameraPageShootCheck.json';
import componentsfacetrackerFaceDirectionModal from './componentsfacetrackerFaceDirectionModal.json';
import componentsUnsupportView from './componentsUnsupportView.json';
import passVaccine from './passVaccine.json';
import error from './error.json';
import cameraIdentityDocumentGlobal from './camera/identity-document/global';

export default {
  general,
  exception,
  topLaunchScreen,
  topInputBirthday,
  topTermsOfUse,
  topPersonalInformation,
  camera: Object.assign({}, camera, {
    descriptions: {
      face: {
        common: {
          manual: {
            'face-front': cameraFaceCommonManualFront,
            'face-action': cameraFaceCommonManualAction
          }
        }
      },
      'identity-document': {
        'drivers-license': {
          manual: {
            'identity-document-front': cameraIdentityDocumentDriversLicenseManualFront,
            'identity-document-diagonal': cameraIdentityDocumentDriversLicenseManualDiagonal,
            'identity-document-back': cameraIdentityDocumentDriversLicenseManualBack
          },
          autodetect: {
            'identity-document-front': cameraIdentityDocumentDriversLicenseAutodetectFront,
            'identity-document-diagonal': cameraIdentityDocumentDriversLicenseAutodetectDiagonal,
            'identity-document-back': cameraIdentityDocumentDriversLicenseAutodetectBack
          }
        },
        'my-number-card': {
          manual: {
            'identity-document-front': cameraIdentityDocumentMyNumberCardManualFront,
            'identity-document-diagonal': cameraIdentityDocumentMyNumberCardManualDiagonal
          },
          autodetect: {
            'identity-document-front': cameraIdentityDocumentMyNumberCardAutodetectFront,
            'identity-document-diagonal': cameraIdentityDocumentMyNumberCardAutodetectDiagonal
          }
        },
        'residence-card': {
          manual: {
            'identity-document-front': cameraIdentityDocumentResidenceCardManualFront,
            'identity-document-diagonal': cameraIdentityDocumentResidenceCardManualDiagonal,
            'identity-document-back': cameraIdentityDocumentResidenceCardManualBack
          }
        },
        'special-permanent-resident-certificate': {
          manual: {
            'identity-document-front': cameraIdentityDocumentSpecialPermanentResidentCertificateManualFront,
            'identity-document-diagonal': cameraIdentityDocumentSpecialPermanentResidentCertificateManualDiagonal,
            'identity-document-back': cameraIdentityDocumentSpecialPermanentResidentCertificateManualBack
          }
        },
        'driving-history-certificate': {
          manual: {
            'identity-document-front': cameraIdentityDocumentDrivingHistoryCertificateManualFront,
            'identity-document-diagonal': cameraIdentityDocumentDrivingHistoryCertificateManualDiagonal,
            'identity-document-back': cameraIdentityDocumentDrivingHistoryCertificateManualBack
          },
          autodetect: {
            'identity-document-front': cameraIdentityDocumentDrivingHistoryCertificateAutodetectFront,
            'identity-document-diagonal': cameraIdentityDocumentDrivingHistoryCertificateAutodetectDiagonal,
            'identity-document-back': cameraIdentityDocumentDrivingHistoryCertificateAutodetectBack
          }
        },
        passport: {
          manual: {
            'identity-document-front': cameraIdentityDocumentPassportManualFront,
            'identity-document-diagonal': cameraIdentityDocumentPassportManualDiagonal,
            'identity-document-back': cameraIdentityDocumentPassportManualBack
          }
        },
        'health-insurance-card': {
          manual: {
            'identity-document-front': cameraIdentityDocumentHealthInsuranceCardManualFront,
            'identity-document-diagonal': cameraIdentityDocumentHealthInsuranceCardManualDiagonal,
            'identity-document-back': cameraIdentityDocumentHealthInsuranceCardManualBack
          }
        },
        'student-notebook': cameraIdentityDocumentStudentNotebook,
        'passport-any-issuance-date': cameraIdentityDocumentPassportAnyIssuanceDate,
        'general-book': cameraIdentityDocumentGeneralBook,
        'general-card': cameraIdentityDocumentGeneralCard,
        global: cameraIdentityDocumentGlobal
      },
      'mynumber-document': {
        'my-number-card': {
          manual: {
            'mynumber-document-front': cameraMynumberDocumentMyNumberCardManualFront,
            'mynumber-document-back': cameraMynumberDocumentMyNumberCardManualBack
          }
        },
        'notification-card': {
          manual: {
            'mynumber-document-front': cameraMynumberDocumentNotificationCardManualFront,
            'mynumber-document-back': cameraMynumberDocumentNotificationCardManualBack
          }
        },
        'residence-certificate': {
          manual: {
            'mynumber-document-front': cameraMynumberDocumentResidenceCertificateManualFront
          }
        }
      },
      'general-purpose-document': {
        common: {
          manual: {
            'general-purpose-document-i18n': cameraGeneralPurposeDocumentCommonManualPage
          }
        }
      },
      'optional-document': {
        common: {
          manual: {
            'optional-document-i18n': cameraOptionalDocumentCommonManualPage
          }
        }
      }
    },
    'camera-mode': cameraMode
  }),
  Root,
  facetrackerFaceDirectionMessage,
  facetrackerFaceDirection,
  applicationCompletion,
  cameraCameraChildError,
  cameraCameraChildConfirmation,
  cameraCameraChildIntroduction,
  cameraCameraChildShooting,
  componentsPageHeader,
  componentsMaintenanceView,
  componentsCameraPageShootCardAuto,
  componentsCameraPageShootCheck,
  componentsfacetrackerFaceDirectionModal,
  componentsUnsupportView,
  passVaccine,
  error
};
